import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import { getCustomAlarmApi, getCustomAlarmGroupApi, updateCustomAlarmApi } from '@/api';
var eventMap = new Map([['hasIrrNoAcpInv', ['有日照值但未發電']],
// 2000 -> redis cache TTL
// ['hasIrrNoAcpInvs', ['有日照值但未發電']],
['hasIrrNoPvp', ['有日照但串列未發電']], ['effUnder85', ['效率低於 85 %']], ['pvTempOver80', ['模組溫度大於 80 °C']], ['envTempOver60', ['環境溫度大於 60 °C']], ['irrOver2000', ['日照計值過高，大於 2000 W/m²']], ['pvaNoCurrent', ['日照值大於 300 W/m²，電流小於 2 A']], ['irrEmpty', ['日照計值無資料']], ['irrLost', ['日照計數值為 0']], ['raUnder60', ['日照值大於 600 W/m²，RA值低於 60 %']], ['invWhichNoPower', ['變流器未發電']], ['rstAllNoPower', ['整場無有效發電']], ['rstLowerThan154v', ['電網電壓異常']], ['pvRALowerThanOthersAvg70', ['MPPT 異常']], ['guaranteedPR', ['整場保證 PR 低於上個月 KPI 設定值']], ['guaranteedAcp', ['整場保證發電量低於上個月 KPI 設定值']], ['smartLoggerDisconnected', ['SmartLogger 斷訊']]
// ['kpiPrFail', ['上月PR小於目標PR或保證PR', 1100]],
// ['kpiAcpFail', ['上月發電量小於目標發電量或保證發電量', 1100]], 不須快取
]);
var systemMap = new Map([[0, '系統正常'], [1, '系統恢復連線'], [3, '裝置斷訊'], [6, '系統未連線'], [7, '系統短暫斷線']]);
var typeMap = new Map([['mailGroup', '電子郵件'], ['lineGroup', 'LINE'], ['telegramGroup', 'Telegram'], ['SMSGroup', '簡訊'], ['phoneCallGroup', '電話']]);
export default {
  name: 'NotificationSettings',
  data: function data() {
    return {
      typeMap: typeMap,
      panel: [0, 1, 2],
      isCheckedSystem: false,
      isCheckedEvent: false,
      selectedSystemAlarms: [],
      selectedEventAlarms: [],
      selectedTypes: [],
      groups: {
        mailGroup: [],
        lineGroup: [],
        telegramGroup: [],
        SMSGroup: [],
        phoneCallGroup: []
      },
      errorMsg: ''
    };
  },
  computed: {
    urlSiteName: function urlSiteName() {
      return this.$route.query.siteName;
    },
    sortTypeList: function sortTypeList() {
      return this.types.map(function (item) {
        return item.value;
      });
    },
    types: function types() {
      return _toConsumableArray(typeMap).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return {
          label: value,
          value: key
        };
      });
    },
    systemAlarmOptions: function systemAlarmOptions() {
      return _toConsumableArray(systemMap).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        return {
          label: value,
          value: key
        };
      });
    },
    eventAlarmOptions: function eventAlarmOptions() {
      return _toConsumableArray(eventMap).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];
        return {
          label: value[0],
          value: key
        };
      });
    }
  },
  watch: {
    selectedSystemAlarms: function selectedSystemAlarms(curr) {
      this.isCheckedSystem = curr.length === this.systemAlarmOptions.length;
    },
    selectedEventAlarms: function selectedEventAlarms(curr) {
      this.isCheckedEvent = curr.length === this.eventAlarmOptions.length;
    }
  },
  methods: {
    handleCheckSystem: function handleCheckSystem(checked) {
      if (checked) {
        this.selectedSystemAlarms = _toConsumableArray(systemMap).map(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 1),
            key = _ref8[0];
          return key;
        });
      } else {
        this.selectedSystemAlarms = [];
      }
    },
    handleCheckEvent: function handleCheckEvent(checked) {
      if (checked) {
        this.selectedEventAlarms = _toConsumableArray(eventMap).map(function (_ref9) {
          var _ref10 = _slicedToArray(_ref9, 1),
            key = _ref10[0];
          return key;
        });
      } else {
        this.selectedEventAlarms = [];
      }
    },
    handleCheckType: function handleCheckType(type) {
      var _this = this;
      this.selectedTypes = this.selectedTypes.sort(function (a, b) {
        return _this.sortTypeList.indexOf(a) - _this.sortTypeList.indexOf(b);
      });
      var isChecked = this.selectedTypes.includes(type);
      if (isChecked) {
        this.handleAddGroupName(type);
      } else {
        this.clearGroupName(type);
      }
    },
    handleAddGroupName: function handleAddGroupName(type) {
      this.groups[type].push('');
    },
    inputGroupName: function inputGroupName(type, index) {
      var _this2 = this;
      // 沒有輸入
      if (!this.groups[type][index]) return;

      // 重複輸入群組名稱
      if (this.groups[type].filter(function (item) {
        return item === _this2.groups[type][index];
      }).length > 1) {
        this.$swal.fire('請輸入不同群組名稱');
        this.handleRemoveGroupName(type, index);
        this.handleAddGroupName(type);
      }
    },
    handleRemoveGroupName: function handleRemoveGroupName(type, index) {
      this.groups[type].splice(index, 1);
    },
    clearGroupName: function clearGroupName(type) {
      this.groups[type] = [];
    },
    filterEmptyValueAndGroup: function filterEmptyValueAndGroup() {
      var _this3 = this;
      // filter empty value
      this.groups = {
        mailGroup: this.groups.mailGroup.filter(function (item) {
          return item;
        }),
        lineGroup: this.groups.lineGroup.filter(function (item) {
          return item;
        }),
        telegramGroup: this.groups.telegramGroup.filter(function (item) {
          return item;
        }),
        SMSGroup: this.groups.SMSGroup.filter(function (item) {
          return item;
        }),
        phoneCallGroup: this.groups.phoneCallGroup.filter(function (item) {
          return item;
        })
      };

      // filter empty group
      this.selectedTypes = Object.keys(this.groups).filter(function (item) {
        return _this3.groups[item].length;
      });
    },
    saveSettings: function saveSettings() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var isGroupNameError;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // check
                _this4.filterEmptyValueAndGroup();

                // 有填寫需檢查 群組名稱
                if (!_this4.selectedTypes.length) {
                  _context.next = 7;
                  break;
                }
                _context.next = 4;
                return _this4.checkGroupNames();
              case 4:
                isGroupNameError = _context.sent;
                if (!isGroupNameError) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return");
              case 7:
                _this4.updateCustomAlarm();
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getCustomAlarm: function getCustomAlarm() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _resData$alarmList, _resData$alarmList2, resData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return getCustomAlarmApi(_this5.urlSiteName);
              case 3:
                res = _context2.sent;
                if (res.data.success) {
                  resData = res.data.data.customAlarm;
                  _this5.groups = {
                    mailGroup: (resData === null || resData === void 0 ? void 0 : resData.mailGroup) || [],
                    lineGroup: (resData === null || resData === void 0 ? void 0 : resData.lineGroup) || [],
                    telegramGroup: (resData === null || resData === void 0 ? void 0 : resData.telegramGroup) || [],
                    SMSGroup: (resData === null || resData === void 0 ? void 0 : resData.SMSGroup) || [],
                    phoneCallGroup: (resData === null || resData === void 0 ? void 0 : resData.phoneCallGroup) || []
                  };
                  _this5.selectedSystemAlarms = (resData === null || resData === void 0 ? void 0 : (_resData$alarmList = resData.alarmList) === null || _resData$alarmList === void 0 ? void 0 : _resData$alarmList.filter(function (item) {
                    return systemMap.has(item);
                  })) || [];
                  _this5.selectedEventAlarms = (resData === null || resData === void 0 ? void 0 : (_resData$alarmList2 = resData.alarmList) === null || _resData$alarmList2 === void 0 ? void 0 : _resData$alarmList2.filter(function (item) {
                    return eventMap.has(item);
                  })) || [];
                  _this5.selectedTypes = Object.keys(_this5.groups).filter(function (item) {
                    return _this5.groups[item].length;
                  });
                }
                _context2.next = 11;
                break;
              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.log('getCustomAlarmApi error', _context2.t0);
                _this5.$swal('無此案場資料');
              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }))();
    },
    checkGroupNames: function checkGroupNames() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _res$data$msg, _res$data$msg$notFoun, res, hasError, _res$data$msg2, _res$data$msg3;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return getCustomAlarmGroupApi(_this6.groups);
              case 3:
                res = _context3.sent;
                hasError = !!((_res$data$msg = res.data.msg) !== null && _res$data$msg !== void 0 && (_res$data$msg$notFoun = _res$data$msg.notFoundGroups) !== null && _res$data$msg$notFoun !== void 0 && _res$data$msg$notFoun.length);
                if (hasError) {
                  _this6.$swal.fire({
                    icon: 'warning',
                    title: (_res$data$msg2 = res.data.msg) === null || _res$data$msg2 === void 0 ? void 0 : _res$data$msg2.message
                  }).then(function (result) {
                    // if (result.isConfirmed) {
                    //   this.handleRemoveGroupName(type, index)
                    //   this.handleAddGroupName(type)
                    // }
                  });
                  _this6.errorMsg = (_res$data$msg3 = res.data.msg) === null || _res$data$msg3 === void 0 ? void 0 : _res$data$msg3.message;
                } else {
                  _this6.errorMsg = '';
                }
                return _context3.abrupt("return", hasError);
              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                console.log('getCustomAlarmGroupApi error', _context3.t0);
              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 9]]);
      }))();
    },
    updateCustomAlarm: function updateCustomAlarm() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = {
                  factoryName: _this7.urlSiteName,
                  customAlarm: _objectSpread(_objectSpread({}, _this7.groups), {}, {
                    alarmList: [].concat(_toConsumableArray(_this7.selectedSystemAlarms), _toConsumableArray(_this7.selectedEventAlarms))
                  })
                };
                _context4.prev = 1;
                _context4.next = 4;
                return updateCustomAlarmApi(data);
              case 4:
                res = _context4.sent;
                if (res.data.success) {
                  _this7.$swal('儲存成功');
                }
                _context4.next = 11;
                break;
              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);
                console.log('updateCustomAlarmApi error', _context4.t0);
              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 8]]);
      }))();
    }
  },
  created: function created() {
    var _this8 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this8.getCustomAlarm();
            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  }
};